// The empty list message: a title, one sentence, and at most one action.
// Nothing else. Not for errors, which are Notice.

import './empty.css'

export function EmptyState({ title, action, children }) {
  return (
    <div className="ui-empty">
      <h3>{title}</h3>
      {children ? <p>{children}</p> : null}
      {action ?? null}
    </div>
  )
}
